/* Radio preferences and a deadline-based, explicit sleep timer. No telemetry leaves the device. */
(() => {
  'use strict';
  if (window.__asifRadioTools) return;
  window.__asifRadioTools = true;
  let deadline = 0;
  let selection = 0;
  let timer = 0;
  let previousMinute = -1;
  const roots = () => document.querySelectorAll('[data-radio-tools]');
  const sync = () => {
    const remaining = deadline ? Math.max(0, Math.ceil((deadline - Date.now()) / 60000)) : 0;
    roots().forEach(root => {
      root.hidden = false;
      const quality = root.querySelector('[data-radio-quality]');
      if (quality && window.AsIfRadio) quality.value = window.AsIfRadio.getState().quality || 'auto';
      const qualityValue = root.querySelector('[data-radio-quality-value]');
      if (qualityValue && quality) qualityValue.textContent = quality.value;
      // 24.09.2026 (Pierre): Die Balken zeigen, welche Stufe gerade laeuft
      // (2 Balken niedrig, 3 mittel, 4 hoch). Unbekannt: alle Balken halb.
      if (quality) {
        let level = null;
        try { level = window.AsIfRadio?.getEffectiveQuality?.() || null; } catch (error) {}
        if (!level && quality.value !== 'auto') level = quality.value;
        root.dataset.level = level || 'unknown';
      }
      const sleep = root.querySelector('[data-radio-sleep-select]');
      if (sleep) {
        sleep.value = String(deadline ? selection : 0);
        root.classList.toggle('is-active', !!deadline);
        const count = root.querySelector('[data-radio-sleep-count]');
        if (count) { count.hidden = !deadline; count.textContent = String(remaining); }
        const status = root.querySelector('[data-radio-sleep-status]');
        if (status && (remaining !== previousMinute || !status.textContent)) status.textContent = deadline ? root.dataset.sleepActive.replace('__MINUTES__', remaining) : root.dataset.sleepOff;
      }
    });
    previousMinute = remaining;
  };
  const check = () => {
    if (deadline && Date.now() >= deadline) {
      deadline = 0;
      window.clearInterval(timer); timer = 0;
      window.dispatchEvent(new CustomEvent('asif:audio-stop'));
    }
    sync();
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-radio-quality]')) { window.AsIfRadio?.setQuality(event.target.value); sync(); }
    if (event.target.matches('[data-radio-sleep-select]')) {
      const minutes = Number(event.target.value);
      if (![0, 15, 30, 60].includes(minutes)) return;
      selection = minutes;
      deadline = minutes ? Date.now() + minutes * 60000 : 0;
      window.clearInterval(timer);
      timer = minutes ? window.setInterval(check, 1000) : 0;
      sync();
    }
  });
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
  window.addEventListener('asif:radio-state', sync);
  window.addEventListener('asif:radio-ready', sync);
  document.addEventListener('asif:page', () => { previousMinute = -1; check(); });
  sync();
})();
